import React from 'react';

import { ADMIN_DASHBOARD, ADMIN_PENDING_HIRES } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';

import { PendingHiresIcon } from '@Generic/icons';

const PendingHiresPage = React.lazy(() => import('../../../pages/Admin/PendingHires/PendingHiresPage'));

export default {
  label: 'navigation.admin.pending-hires',
  group: ADMIN,
  to: '/administration/pending-hires',
  route: '/administration/pending-hires',
  area: ADMIN_PENDING_HIRES,
  component: PendingHiresPage,
  icon: <PendingHiresIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  hasNavBar: true,
};
